// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
});

/*
 * Help dialog for Email Dispatch
 */

class EmailHelp extends Component {
  state = {
  }
  
  render() {
    // eslint-disable-next-line    
    const { classes, open, onClose, anchorEl,type } = this.props;

    return (
      <React.Fragment>
        <MuiCore.Popover open={open}
                         anchorEl={anchorEl}
                         anchorOrigin={{
                           vertical: 'bottom',
                           horizontal: 'center',
                         }}
                         transformOrigin={{
                           vertical: 'top',
                           horizontal: 'center',
                         }}
                         onClose={onClose}>
          <ol style={{margin: 10}}>
            <li>Enter your <b>{type ==='TWILIO' ? "phone number with country code " : type + " address."}</b> </li>
            <li>Click on <b>Verify</b> below.</li>
            <li>Enter the <b>verification code</b> from the {type ==='TWILIO' ? "SMS" : type} we have sent you.</li>
          </ol>
        </MuiCore.Popover>
      </React.Fragment>
    );
  }
}

EmailHelp.propTypes = {
  open : PropTypes.bool.isRequired,
  onClose : PropTypes.func.isRequired,
  anchorEl : PropTypes.object,
}

EmailHelp.defaultProps = {
  open : false,
}


export default withStyles(styles)(EmailHelp);